var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 29,
    viewBox: "0 0 30 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.625 4.14286H24.375C25.4121 4.14286 26.25 5.06853 26.25 6.21429V22.7857C26.25 23.9315 25.4121 24.8571 24.375 24.8571H20.625C19.5879 24.8571 18.75 25.7828 18.75 26.9286C18.75 28.0743 19.5879 29 20.625 29H24.375C27.4805 29 30 26.2165 30 22.7857V6.21429C30 2.78348 27.4805 0 24.375 0H20.625C19.5879 0 18.75 0.92567 18.75 2.07143C18.75 3.21719 19.5879 4.14286 20.625 4.14286ZM20.1855 15.6263C20.4668 15.335 20.625 14.9272 20.625 14.5C20.625 14.0728 20.4668 13.665 20.1855 13.3737L11.748 4.57009C11.3379 4.14286 10.7402 4.02634 10.2246 4.27232C9.70898 4.5183 9.375 5.08147 9.375 5.69643V10.3571H1.875C0.837891 10.3571 0 11.2828 0 12.4286V16.5714C0 17.7172 0.837891 18.6429 1.875 18.6429H9.375V23.3036C9.375 23.925 9.70898 24.4817 10.2246 24.7277C10.7402 24.9737 11.3379 24.8571 11.748 24.4299L20.1855 15.6263Z",
    fill: "#1E3859"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogin);
export default __webpack_public_path__ + "static/media/login.0db7d90b596f388010ad529c64ee5a14.svg";
export { ForwardRef as ReactComponent };